export const NO_SERVICE = 'none';

export const getmainSubServiceName = singleUser => `${singleUser?.mainService?.name} - ${singleUser?.subService?.name}`;
